import { inject, Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';

import {
  FeatureAvailabilityDialogComponent,
  FeatureAvailabilityDialogData,
} from '../components/dialogs/feature-availability-dialog/feature-availability-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class FeatureAvailabilityService {
  private dialog = inject(MatDialog);
  private translateService = inject(TranslateService);

  showFeatureAvailabilityDialog(featureKey: string): Observable<{ notify: boolean } | undefined> {
    const featureName = this.translateService.instant(featureKey);

    const dialogRef = this.dialog.open(FeatureAvailabilityDialogComponent, {
      data: { featureName } as FeatureAvailabilityDialogData,
      disableClose: true,
      autoFocus: true,
    });

    return dialogRef.afterClosed();
  }
}
